export function onFormatDate(date: Date): string {

    if (typeof (date) === 'string') {
      date = new Date(date);
    }
  
    let day = String(date.getDate());
    day = day.length === 1 ? '0' + day : day;
  
    let month = String(date.getMonth() + 1);
    month = month.length === 1 ? '0' + month : month;
  
    if (typeof (date) === 'object') {
      return day + '/' + month + '/' + (date.getFullYear());
    } else {
      return date;
    }
  };